import React from "react"
import styled from "styled-components"
import Spacing from "@irati/ui/src/Spacing"
import {Body, H2, H3} from "@irati/ui/src/Typography"
import FilterBy from "@irati/ui/src/FilterBy"
import {basket} from "./dummyData"
import {ButtonRouterLink, RouterLink} from "@irati/ui/src/Link"
import Item from "../components/Item"

const BasketScreen = () => {
  return (
    <OuterContainer>
      <TitleContainer>
        <Title>Basket</Title>
        <FilterBy
          loadFilterOptions={null}
          allOptionsSelectedLabel="24 months"
          filterOptions={[]}
          onSelect={() => {}}
          onSelectAll={() => {}}
          onReset={() => {}}
          onFilter={() => {}}
          multipleOptionsSelectedLabel="Several options selected"
          allOptionText="All Options"
        />
      </TitleContainer>

      {/* Items */}
      <Spacing paddingTop={2} paddingBottom={3.75}>
        {basket.basketItems.map(({imageUrl, name, price}, index) => {
          return <Item imageUrl={imageUrl} name={name} price={price} key={index} />
        })}
      </Spacing>

      <Spacing paddingBottom={3}>
        {/* Total amount */}
        <H3 marginBottom={2}>Order totals</H3>

        <OrderTotalRow>
          <OrderTotalContent>
            <Body>Total amount from take home pay ({basket.count} items):</Body>
          </OrderTotalContent>
          <OrderTotalPrice>
            <TotalPrice>£{basket.monthlyPrice}</TotalPrice>
            <Body>Per month for {basket.term} months</Body>
          </OrderTotalPrice>
        </OrderTotalRow>
      </Spacing>

      <hr />

      <Spacing paddingBottom={3}>
        <OrderTotalRow>
          <OrderTotalContent>
            <Body>Total gross monthly reduction:</Body>
          </OrderTotalContent>
          <OrderTotalPrice>
            <Body>£{basket.totalMonthlyGrossAmount}</Body>
            <Body>As seen on payslip</Body>
          </OrderTotalPrice>
        </OrderTotalRow>
      </Spacing>

      <ButtonRow>
        <StyledRouterLink to="/products">&lt; Continue shopping</StyledRouterLink>
        <ContinueButtonContainer>
          <ButtonRouterLink to="/checkout" full primary>
            Continue to order
          </ButtonRouterLink>
        </ContinueButtonContainer>
      </ButtonRow>
    </OuterContainer>
  )
}

export default BasketScreen

const OuterContainer = styled.div`
  padding: 32px;
  max-width: 1080px;
  margin: 0 auto;
`

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const Title = styled(H2)`
  line-height: 30px;
  font-size: 24px;
  margin: 0;
  font-weight: 700;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    line-height: 40px;
    font-size: 32px;
  `}
`

const OrderTotalRow = styled.div`
  display: flex;
`

const OrderTotalContent = styled.div`
  flex-basis: 50%;
  justify-content: start;
`

const OrderTotalPrice = styled.div`
  flex-basis: 50%;
  justify-content: end;
  display: flex;
  flex-direction: column;
  align-items: end;
`

const TotalPrice = styled(Body)`
  font-size: 24px;
  font-weight: 700;
  color: ${({theme}) => theme.colors.primary1};
  margin-bottom: 8px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    font-size: 32px;
  `}
`

const ButtonRow = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    flex-direction: row;
    justify-content: space-between;
  `}
`

const ContinueButtonContainer = styled.div`
  width: 100%;
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    width: 280px;
  `}
`

const StyledRouterLink = styled(RouterLink)`
  margin-top: 12px;
` as typeof RouterLink
